import moment from 'moment';

export const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const arrayBufferToBase64 = (buffer) => {
    var base64data = Buffer.from(buffer, 'binary').toString('base64');
    return base64data;
};


export const IsNoU = (x) => { 
    if (x === undefined || x === null) return true;  return false; 
}

export const padding_2zero = (str) =>
{
    //var str = "" + 1
    str = "" + str;
    var pad = "00";
    var ans = pad.substring(0, pad.length - str.length) + str;
    return ans;
}

export const adCheckStatus = advertise => {

  const today = new Date();
  
  // if (advertise.startDate <= today && today < advertise.endDate)
  //   return 'success';
  // else if (today < advertise.startDate)
  //   return 'primary';

  let isAfter = moment(today).isAfter(moment(advertise.start_date), 'day');
  let isSame = moment(today).isSame(moment(advertise.start_date), 'day');
  let isBefore = moment(today).isBefore(moment(advertise.end_date), 'day');

  // console.log(today);
  // console.log(advertise.start_date);
  // console.log(advertise.end_date);
  // console.log(advertise.play_count);
  // console.log('is After -> ' + isAfter);
  // console.log('is Same -> ' + isSame);
  // console.log('is Before -> ' + isBefore);

  // valid
  if ((isAfter || isSame) && isBefore) {

      let valuePlayCount = 0;
      let valueViewCount = 0;
      if (!IsNoU(advertise.play_count) && advertise.play_count.length > 0) {
        valuePlayCount = Number(advertise.play_count.replace(/\D/g, ''));
      }
      if (!IsNoU(advertise.view_count) && advertise.view_count.length > 0) {
        valueViewCount = Number(advertise.view_count.replace(/\D/g, ''));
      }
      //console.log('check -> ' + valuePlayCount + ',' + valueViewCount);
      if ((valueViewCount === 0 || valuePlayCount < valueViewCount) || advertise.type === 'free') {
        return 'success'; 
      }
      else if (valuePlayCount >= valueViewCount) {
        return 'danger';
      }
  }
  else if (moment(today).isBefore(moment(advertise.start_date), 'day')) // reserved
    return 'primary';

  return 'danger';  // expired
}

export const timeToKorTime = (utc_time) => {

    const kor_time = new Date(utc_time);

    kor_time.setHours(kor_time.getHours() + 9);

    return kor_time.toString();

}